import {
  CREATE_CREW_REQUEST,
  CREATE_CREW_ERROR,
  CREATE_CREW_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/createEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default entity => (state = initialState, action) => {

  context.init(context);

  context.CREATE_ENTITY_REQUEST = CREATE_CREW_REQUEST;
  context.CREATE_ENTITY_ERROR = CREATE_CREW_ERROR;
  context.CREATE_ENTITY_SUCCESS = CREATE_CREW_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "crew";
  context.entityLocation = RESOURCES.Crews;
  context.hasOrganisation = true;

  return context.execute(context)(entity)(state, action);
};